import { AddPhotoState } from './addPhoto.types';

export const reducerInitialState: AddPhotoState = {
  fileProgressValues: {},
};
